import get from 'lodash/get';
import some from 'lodash/some';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import endpointsResource from 'src/actions/endpoints/endpointsResource';

export const validateAddressUnique: sharedTypes.AppThunk = (currentValue: any) => (dispatch, getState) => {
  const listOfEndpoints = get(getState(), 'endpoints.values', []);
  const theSameAddressExists = some(
    listOfEndpoints,
    endpoint =>
      endpoint.id !== currentValue.id &&
      endpoint.address.trim().toLowerCase() === currentValue.address.trim().toLowerCase()
  );
  if (theSameAddressExists) {
    dispatch(
      endpointsResource.actions.validationError([
        {
          attr: 'address',
          code: 'AddressUnique',
          detail: 'Name already exists',
        },
      ])
    );
    return false;
  }
  return true;
};
